

export type HTMLElementDataSetMap = Record<string, string>

/**
 * adds dataset attributes to element. Key names are converted from camel-case to kebab-case.
 * Example: Input { sdgMediaElement: '1'} will translate into element.dataset['sdg-media-element']
 */

export const setDataset = (element: HTMLElement, dataset: HTMLElementDataSetMap) => {
    Object.entries(dataset).forEach(([key, value]) => {
        element.dataset[key] = value;
    })
}
